module.exports = __webpack_public_path__ + "img/banner.ec6c5f12.png";